/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_5a8a838c"]'><cube-divider text="文本内容"/></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5a8a838c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5a8a838c"}
  /** script content **/
  require("./divider-text.mpx.js?isComponent&outputPath=components%2Fdivider-text5a8a838c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./divider-text.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdivider-text5a8a838c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5a8a838c"],
    ctorType: "component",
    outputPath: "components/divider-text5a8a838c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>